(function () {
	'use strict';

	if (!document.querySelector('.uvindex')) {
		return;
	}

	var backgroundBoxesPlugin = {
		id: 'backgroundBoxes',
		beforeDatasetsDraw: function (chart, args, options) {
			const ctx = chart.ctx;
			const yAxis = chart.scales.y;
			const chartArea = chart.chartArea;

			let maxDataValue =
				Math.max(...chart.data.datasets.flatMap((dataset) => (dataset.hidden ? [] : dataset.data))) || 1;
			options.boxes.forEach(function (box) {
				if (maxDataValue < box.yMin) {
					return;
				}

				const yMinPixel = yAxis.getPixelForValue(box.yMin);
				const yMaxValue = box.yMax === 'max' || box.yMax === undefined ? yAxis.max : box.yMax;
				const yMaxPixel = yAxis.getPixelForValue(yMaxValue > maxDataValue ? yAxis.max : yMaxValue);

				let xMinPixel = chartArea.left;
				if (box.xMin !== undefined && !isNaN(box.xMin)) {
					xMinPixel += (chartArea.right - chartArea.left) * box.xMin;
				}

				const boxWidth = chartArea.right - xMinPixel;

				ctx.fillStyle = box.backgroundColor;
				ctx.fillRect(xMinPixel, yMaxPixel, boxWidth, yMinPixel - yMaxPixel);
			});
		},
	};

	let lastHoveredLegendItemIndex = null;

	function isMobile() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }

	function handleHover(hoveredLegendItemIndex, chart) {
		if (lastHoveredLegendItemIndex !== hoveredLegendItemIndex) {
			chart.data.datasets.forEach((dataset, index) => {
				const newOpacity = index === hoveredLegendItemIndex ? 1 : 0.1;
				dataset.borderColor = `rgba(0, 0, 0, ${newOpacity})`;
			});
			lastHoveredLegendItemIndex = hoveredLegendItemIndex;
			chart.update();
		}
	}

	function handleLeave(chart) {
		if (lastHoveredLegendItemIndex !== null) {
			chart.data.datasets.forEach((dataset, index) => {
				const originalOpacity = 1; // - index * 0.1;
				dataset.borderColor = `rgba(0, 0, 0, ${originalOpacity})`;
			});
			lastHoveredLegendItemIndex = null;
			chart.update();
		}
	}

	const htmlLegendPlugin = {
		id: 'htmlLegend',
		afterUpdate(chart, args, options) {
			const legendContainer = document.getElementById(options.containerID);
			let ul = legendContainer.querySelector('ul');

			if (!ul) {
				ul = document.createElement('ul');
				ul.style.display = 'flex';
				ul.style.flexDirection = 'row';
				ul.style.margin = 0;
				ul.style.padding = 0;
				ul.style.listStyleType = 'none';
				ul.style.width = '100%';
				ul.style.justifyContent = 'space-around';
				ul.style.boxSizing = 'border-box';
				legendContainer.appendChild(ul);
			} else {
				ul.innerHTML = '';
			}

			const items = chart.options.plugins.legend.labels.generateLabels(chart);
			items.forEach((item, itemIndex) => {
				const li = document.createElement('li');
				li.style.display = 'flex';
				li.style.alignItems = 'center';
				li.style.flexBasis = '0';
				li.style.flexGrow = '1';

				const button = document.createElement('button');
				button.classList.add('uvindex-forecast-button');

				if (!isMobile()) {
					li.onclick = () => {
						const isVisible = chart.isDatasetVisible(item.datasetIndex);
						const visibleDatasetsCount = chart.data.datasets.filter((ds, i) => chart.isDatasetVisible(i)).length;
						if (isVisible && visibleDatasetsCount === 1) return;

						chart.setDatasetVisibility(item.datasetIndex, !isVisible);
						chart.update();
					};

					li.addEventListener('mouseenter', () => handleHover(itemIndex, chart));
					li.addEventListener('mouseleave', () => handleLeave(chart));
				}
				else {
					button.addEventListener('click', () => {
						const isVisible = chart.isDatasetVisible(item.datasetIndex);
						const visibleDatasetsCount = chart.data.datasets.filter((ds, i) => chart.isDatasetVisible(i)).length;
						
						if (isVisible && visibleDatasetsCount === 1) return;
				
						chart.setDatasetVisibility(item.datasetIndex, !isVisible);
						chart.update();
					});
				}

				const textContainer = document.createElement('p');
				textContainer.className = 'uvindex-forecast-chart-legend-item';

				textContainer.style.border = item.hidden ? '1px solid' : '1px solid #9B2C98';
				textContainer.style.background = item.hidden ? '#fff' : '#9B2C98';

				const textSpan = document.createElement('span');
				textSpan.className = 'uvindex-forecast-chart-legend';
				textSpan.textContent = item.text;
				textSpan.style.color = item.hidden ? 'item.fontColor' : '#fff';

				const style = lineStyles[itemIndex % lineStyles.length];
				const lineSpan = document.createElement('span');
				lineSpan.className = 'uvindex-forecast-chart-legend-linespan';

				switch (style) {
					case 'dashed':
						lineSpan.style.borderBottom = '2px dashed black';
						break;
					case 'dotted':
						lineSpan.style.borderBottom = '2px dotted black';
						break;
					case 'largedashed':
						lineSpan.style.borderBottom = '4px dashed black';
						break;
					case 'largedotted':
						lineSpan.style.borderBottom = '4px dotted black';
						break;
					default:
						lineSpan.style.borderBottom = '2px solid black';
				}

				textSpan.appendChild(lineSpan);
				textContainer.appendChild(textSpan);
				button.appendChild(textContainer);
				li.appendChild(button);
				ul.appendChild(li);
			});
			legendContainer.appendChild(ul);
		},
	};

	const lineStyles = ['solid', 'dashed', 'dotted', 'largedashed', 'largedotted'];

	function createChart(dataWithDates) {
		var ctx = document.getElementById('hourlyUvIndex').getContext('2d');

		const datasets = dataWithDates.map((item, index) => {
			let borderDash;
			let borderWidth;
			let borderCapStyle = '';
			switch (lineStyles[index % lineStyles.length]) {
				case 'dashed':
					borderDash = [5, 5];
					borderWidth = 2;

					break;
				case 'dotted':
					borderDash = [2, 3];
					borderWidth = 2;

					break;
				case 'largedashed':
					borderDash = [8, 5];
					borderWidth = 4;

					break;
				case 'largedotted':
					borderDash = [1, 8];
					borderWidth = 4;
					borderCapStyle = 'round';
					break;

				default:
					borderDash = [];
					borderWidth = 2;
			}
			return {
				label: item.dateLabel,
				data: item.hourlyUvIndex,
				borderColor: 'rgba(0, 0, 0, 1)',
				borderWidth: borderWidth,
				borderDash: borderDash,
				fill: false,
				borderCapStyle: borderCapStyle,
				hidden: index !== 0,
			};
		});

		return new Chart(ctx, {
			type: 'line',
			data: {
				labels: Array.from({ length: 24 }, (_, i) => `${i}:00`),
				datasets: datasets,
			},
			options: {
				showLine: true,
				responsive: true,
				maintainAspectRatio: false,
				pointStyle: false,
				elements: {
					line: {
						tension: 0.4,
					},
				},
				scales: {
					y: {
						beginAtZero: true,
						grid: {
							display: false,
							drawBorder: false,
							drawTicks: false,
						},
						ticks: {
							padding: 6,
							maxTicksLimit: 18,
							stepSize: 1,
						},
					},
					x: {
						grid: {
							display: false,
							drawBorder: false,
							drawTicks: false,
						},
						ticks: {
							autoSkip: true,
							maxTicksLimit: 8,
							padding: 10,
						},
					},
				},

				plugins: {
					htmlLegend: { containerID: 'legend-container' },
					legend: { display: false },
					tooltip: {
						displayColors: false,
						callbacks: {
							label: function (data) {
								let value = data.dataset.label + ': ' + data.formattedValue.toLocaleString().replace('.', ',');
								return value;
							}
						}
					},

					backgroundBoxes: {
						boxes: [
							{
								yMin: 0,
								yMax: 1,
								backgroundColor: 'rgba(190, 190, 190, 1)',
							},
							{
								yMin: 1,
								yMax: 2,
								backgroundColor: 'rgba(78, 180, 0, 1)',
							},
							{
								yMin: 2,
								yMax: 3,
								backgroundColor: 'rgba(160, 206, 0, 1)',
							},
							{
								yMin: 3,
								yMax: 4,
								backgroundColor: 'rgba(247, 228, 0, 1)',
							},
							{
								yMin: 4,
								yMax: 5,
								backgroundColor: 'rgba(248, 182, 0, 1)'
							},
							{
								yMin: 5,
								yMax: 6,
								backgroundColor: 'rgba(248, 135, 0, 1)'
							},
							{
								yMin: 6,
								yMax: 7,
								backgroundColor: 'rgba(248, 89, 0, 1)'
							},
							{
								yMin: 7,
								yMax: 8,
								backgroundColor: 'rgba(232, 44, 14, 1)'
							},
							{
								yMin: 8,
								yMax: 9,
								backgroundColor: 'rgba(216, 0, 29, 1)'
							},
							{
								yMin: 9,
								yMax: 10,
								backgroundColor: 'rgba(255, 0, 153, 1)'
							},
							{
								yMin: 10,
								yMax: 11,
								backgroundColor: 'rgba(181, 76, 255, 1)'
							},
							{
								yMin: 11,
								yMax: 12,
								backgroundColor: 'rgba(153, 140, 255, 1)'
							},
							{
								yMin: 12,
								yMax: 13,
								backgroundColor: 'rgba(133, 120, 235, 1)'
							},
							{
								yMin: 13,
								yMax: 14,
								backgroundColor: 'rgba(113, 100, 215, 1)'
							},
							{
								yMin: 14,
								yMax: 15,
								backgroundColor: 'rgba(93, 80, 195, 1)'
							},
							{
								yMin: 15,
								yMax: 16,
								backgroundColor: 'rgba(73, 60, 175, 1)'
							},
							{
								yMin: 16,
								yMax: 17,
								backgroundColor: 'rgba(53, 40, 155, 1)'
							},
							{
								yMin: 17,
								yMax: 'max',
								backgroundColor: 'rgba(33, 20, 135, 1)',
							},
							{
								yMin: 0,
								yMax: 'max',
								xMin: 0.014,
								backgroundColor: 'rgba(255, 255, 255, 0.85)',
							},
						],
					},
				},
				interaction: {
					intersect: false,
					mode: 'index',
				},
				animation: {
					duration: 1100,
					easing: 'easeOutQuint',
					show: {},
				},
				animations: {
					y: {
						duration: 1100,
						easing: 'easeInOutQuart',
					},
				},
			},
			plugins: [backgroundBoxesPlugin, htmlLegendPlugin],
		});
	}

	function updateChart(chart, newDataWithDates) {
		chart.data.datasets = chart.data.datasets.filter((dataset) =>
			newDataWithDates.some((newDataset) => newDataset.dateLabel === dataset.label)
		);

		newDataWithDates.forEach((newDataset, index) => {
			const existingDataset = chart.data.datasets.find((dataset) => dataset.label === newDataset.dateLabel);
			if (existingDataset) {
				existingDataset.data = newDataset.hourlyUvIndex;
				existingDataset.hidden = index !== 0;
			} else {
				const newDatasetConfig = {
					label: newDataset.dateLabel,
					data: newDataset.hourlyUvIndex,
					borderColor: `rgba(0, 0, 0, ${1 - index * 0.2})`,
					borderWidth: 2,
					borderDash: lineStyles[index % lineStyles.length],
					fill: false,
					hidden: index !== 0,
				};
				chart.data.datasets.push(newDatasetConfig);
			}
		});
		chart.update('active');
	}

	window.createChart = createChart;
	window.updateChart = updateChart;
})();